"use client";

import { useLocale } from "next-intl";
import { KlaroProvider } from "./klaro-provider";
import "klaro/dist/klaro.min.css";

export default function ConsentManager() {
  const locale = useLocale();

  return (
    <>
      <div id="klaro" />
      <div id="consent-notice" />
      <KlaroProvider locale={locale} />
    </>
  );
}
